'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIBreakString from 'UIComponents/text/UIBreakString';
import SanitizedText from 'sanitize-text/components/SanitizedText';

const Benefits = ({
  benefits
}) => /*#__PURE__*/_jsx(UIBreakString, {
  children: /*#__PURE__*/_jsx(SanitizedText, {
    body: benefits
  })
});

Benefits.propTypes = {
  benefits: PropTypes.string.isRequired
};
export default Benefits;